import { useState } from "react";

import { useStore } from "storev2/formStore";
import Attachment from "components/Attachment/Attachment";
// import MenuReport from "components/MeForm/MenuReport";
// import MenuWizard from "components/MeForm/MenuWizard";
import {
  saveIcon,
  deleteIcon,
  attachmentIcon,
} from "componentsv2/icon/iconForm";
import { cn } from "tools/ui";

const styleHead =
  "flex py-2 w-full px-3 lg:px-4 lg:pt-1.5 md:col-span-2 lg:col-span-2 xl:col-span-2";
// const colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";

function ToolbarForm({ layout, storeId, onAction }) {
  const { model, form_action, access } = layout;
  const [viewAttach, setViewAttach] = useState(false);
  const { deleteRecord, save, findRecord } = useStore.getState();
  const { active: record } = findRecord(storeId);
  console.log("active....", record);
  console.log("layout....", layout);
  let btnAttachment;
  let btnDelete;
  let btnSave;
  let btnReports;
  let btnWizards;

  if (form_action) {
    btnAttachment = form_action.includes("attachment");
    let accessDelete = true;
    if (access?.delete) {
      // must return true or false depends of the record evaluation
      accessDelete = access.delete(record.active);
    }
    if (accessDelete) {
      btnDelete = form_action.includes("delete");
    }
    // if (record.id > 0) {
    //   btnSave = form_action.includes("edit");
    // }
    /***the save button is necessary when the user is filling out the form
     *  and wants to save the form so as not to lose all the information,
     * e.g., shipment internal  */
    let accessEdit = true;
    if (access?.edit) {
      // must return true or false depends of the record evaluation
      accessEdit = access.edit(record.id);
    }
    if (accessEdit) {
      btnSave = form_action.includes("edit");
    }
    btnReports = layout.reports;
    btnWizards = layout.wizards;
  }
  // FIXME: Add report if exists change to true trigger generate
  // const report = false;

  function onSave() {
    save(model, record.id);
  }

  function onDelete() {
    deleteRecord(model, record.id);
    if (onAction) onAction("delete", record.id);
  }

  function onAttachment() {
    setViewAttach(true);
  }

  const toolbar = btnSave || btnAttachment || btnReports || btnDelete;

  // {btnReports && <MenuReport layout={layout} activeRecord={record} />}
  // {btnWizards && <MenuWizard layout={layout} activeRecord={record} />}
  return (
    <div id="head-form" className={cn(styleHead)}>
      <div className="flex ml-auto my-auto rounded-md px-3 space-x-6">
        {saveIcon(btnSave, onSave)}
        {attachmentIcon(btnAttachment, onAttachment)}
        {deleteIcon(btnDelete, onDelete)}
      </div>
      {viewAttach && (
        <Attachment
          activeRecord={record.id}
          onClose={() => {
            setViewAttach(false);
          }}
          layout={layout}
          open={viewAttach}
        />
      )}
    </div>
  );
}

export default ToolbarForm;
